import React from 'react';
import {connect} from 'react-redux';
import TicketsSelection from "./TicketsSelection/TicketsSelection";
import SeatsSelection from "./SeatsSelection/SeatsSelection";
import CandybarSelection from "./Candybar/CandybarSelection";
import PaymentMethodSelection from "./PaymentMethodSelection";
import PaymentSelection from "./PaymentSelection";
import PaymentSidebar from "./PaymentSidebar";
import ConfirmationScreen from './Confirmation/ConfirmationScreen';
import {parseOrderAmountByPaymentMethod} from '../../utils/checkout';
import IeNipPanel from './IeNipPanel';
import { nipRequestCancel, nipRequestSubmit } from '../../actions/creators/checkout/paymentSuggestions';
import {
  getAppConfig,
  getCheckoutConfirmationData,
  getCheckoutContext,
  getCheckoutNipCode,
  getCheckoutPaymentGateway,
  getCheckoutPaymentMethod,
  getCheckoutSelectedPaymentOption,
  getCheckoutStep,
  getPayPalClientMetadataId
} from '../../reducers';
import { AnalyticsCheckout } from '../../utils/analytics';
import { CHECKOUT_CONTEXT_CANDYBAR, CHECKOUT_CONTEXT_TICKETS } from '../../actions/creators/checkout';
import CinemaMaintenanceLegend from '../common/CinemaMaintenanceLegend';
import OrderReview from './OrderReview';
import { CHECKOUT_STEPS, isCheckoutOrderReviewed } from '../../reducers/checkoutData';

class CheckoutContent extends React.Component {
  constructor(props) {
    super(props);

    this.fraudNetOptions = null;
    this.fraudNetScript = null;
  }

  componentDidMount() {
    if (this.props.clientMetadataId) {
      this.renderFraudnet();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.step !== this.props.step) {
      window.scrollTo(0, 0);

      if (CHECKOUT_CONTEXT_TICKETS === this.props.context) {
        // @todo Move to a middleware
        AnalyticsCheckout.trackStep(this.props.step, {
          session: this.props.data,
          movie: this.props.movie,
          cinema: this.props.cinema,
          transaction: this.props.step === CHECKOUT_STEPS.CONFIRMATION ? this.props.confirmationData : null,
          order: {
            tickets: this.props.tickets
          }
        });
      }
    }

    if (this.props.clientMetadataId && prevProps.clientMetadataId !== this.props.clientMetadataId) {
      this.renderFraudnet();
    }
  }

  componentWillUnmount() {
    console.log(this.fraudNetOptions, this.fraudNetScript);
    if (this.fraudNetOptions) document.body.removeChild(this.fraudNetOptions);
    if (this.fraudNetScript) document.body.removeChild(this.fraudNetScript);

    this.fraudNetOptions = null;
    this.fraudNetScript = null;
  }

  getStep() {
    switch(this.props.step) {
      case CHECKOUT_STEPS.TICKETS:
        return <TicketsSelection tickets={this.props.tickets} ticketsSum={this.props.ticketsSum} session={this.props.data}/>;
      case CHECKOUT_STEPS.SEATS:
        return <SeatsSelection session={this.props.data} />;
      case CHECKOUT_STEPS.CANDYBAR:
        return this.renderCandybarContent();
      case CHECKOUT_STEPS.PAYMENT_SUGGESTIONS:
        return <PaymentMethodSelection/>;
      case CHECKOUT_STEPS.ORDER_REVIEW:
        return <OrderReview/>;
      case CHECKOUT_STEPS.PAYMENT:
        return <PaymentSelection/>;
      default:
        return '';
    }
  }

  renderCandybarContent() {
    const props = {};
    const { context } = this.props;

    if (CHECKOUT_CONTEXT_CANDYBAR === context) {
      props.cinemaId = this.props.cinema && this.props.cinema.id;
    } else {
      props.sessionId = this.props.data && this.props.data.id;
    }
    
    return <CandybarSelection {...props}/>;
  }

  getPaymentSidebar() {
    const usingDefaultGateway =  this.props.paymentGateway === 'default';
    const isLastStep = !this.props.nextStep;

    if (!isLastStep || !this.props.isOrderReviewed) {
      return '';
    }
    
    const isNipInputRequired = this.props.ccRequired && this.props.nipRequired && !this.props.nip;
    if (isNipInputRequired) {
      return <IeNipPanel onCancel={this.props.nipRequestCancel} onSubmit={this.props.nipRequestSubmit} />;
    }
    
    if (
      (!this.props.ccRequired && this.props.nipRequired)
      ||
      (this.props.paymentMethod && (usingDefaultGateway || this.props.paymentGateway === 'stripe-elements' || this.props.paymentMethod !== 'credit-card'))
      ||
      (!this.props.paymentMethod && !this.props.cash && !this.props.nipRequired)
    ) {
      return <PaymentSidebar paymentMethod={this.props.paymentMethod} cash={this.props.cash}/>;
    } else {
      return '';
    }
  }

  renderFraudnet() {
    let script = document.createElement('script');
    script.setAttribute('type', 'application/json');
    script.setAttribute('fncls', 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99');
    script.innerHTML = JSON.stringify({
        "f": this.props.clientMetadataId,
        "s": this.props.payPalMerchantId
    });
    document.body.appendChild(script);
    this.fraudNetOptions = script;

    script = document.createElement('script');
    script.src = "https://c.paypal.com/da/r/fb.js";
    document.body.appendChild(script);
    this.fraudNetScript = script;
  }

  render() {

    if (!!this.props.cinema && 'maintenance' === this.props.cinema.status) {
      return <div className='text-center'><CinemaMaintenanceLegend text={this.props.cinema.maintenance_message} /></div>;
    }

    return (
        <React.Fragment>
          {this.props.step === 'confirmation' && <ConfirmationScreen data={this.props.confirmationData}/>}
          {this.getStep()}
          {this.getPaymentSidebar()}

          {CHECKOUT_CONTEXT_TICKETS === this.props.context && <p className="mt-3 checkout-disclaimer">
            Los boletos son válidos únicamente para el día y horario seleccionado. No se realizarán reembolsos ni cambios de horarios una vez realizada la compra.
          </p>}
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  // const {options, selected} = state.checkoutData.paymentSuggestions;
  // const amountByMethod = options && selected ? parseOrderAmountByPaymentMethod(options[selected]) : {};
  const amountByMethod = parseOrderAmountByPaymentMethod(getCheckoutSelectedPaymentOption(state));
  const cash = ('cash' in amountByMethod) ? amountByMethod.cash : 0;
  const ccRequired = cash > 0;
  const nipRequired = ('ie' in amountByMethod && amountByMethod.ie > 0) // @todo check isCheckoutIeNipRequired function as it does exactly the same thing.
      || ('passes' in amountByMethod && amountByMethod.passes > 0);
  const paypal = getAppConfig(state).paypal;

  return {
    cash,
    ccRequired,
    clientMetadataId: getPayPalClientMetadataId(state),
    confirmationData: getCheckoutConfirmationData(state),
    context: getCheckoutContext(state),
    data: state.checkoutData.data,
    isOrderReviewed: isCheckoutOrderReviewed(state),
    nip: getCheckoutNipCode(state),
    nipRequired,
    paymentMethod: getCheckoutPaymentMethod(state),
    paymentGateway: getCheckoutPaymentGateway(state),
    payPalMerchantId: paypal ? paypal.merchant_id : null,
    step: getCheckoutStep(state),
    tickets: props.tickets,
    ticketsSum: props.ticketsSum,
  }
};

const mapDispatchToProps = dispatch => ({
  nipRequestCancel: () => dispatch(nipRequestCancel()),
  nipRequestSubmit: nip => dispatch(nipRequestSubmit(nip)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckoutContent);